module.exports = __webpack_public_path__ + "img/worksbot_img19112526.f80b946f.jpg";